$(document).on('turbolinks:load', () => {
  $('.profile-info').mouseover(() => {
    $('.settings').removeClass('hidden');
  });

  $('.profile-info').mouseout(() => {
    $('.settings').addClass('hidden');
  });
});
